/* eslint-disable no-console */
import * as React from 'react';

import { SiteUrlsProps } from '~src/app/selectors/SiteUrlsSelectors';
import {
  EditPublishedConnectionEntityAction,
} from '~src/app/spaces/ActionsMenu/EntityActions/EditPublishedConnectionEntityAction';
import { ItemDescription } from '~src/app/spaces/Header/HeaderItemDescription';
import {
  ExtractStatusMetadata,
  ModifiedDateMetadata,
  OwnerMetadata,
  PublishedConnectionPolicyMetaData,
} from '~src/app/spaces/Header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '~src/app/spaces/Header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/app/spaces/Header/SpaceHeader';
import { sanitize } from '~src/commonInfra/utils/Sanitize';
import { isPublishedConnectionTableInfo } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';
import { IPublishedConnectionTableActions } from '~src/ts/ServerApi/types/IPublishedConnectionTableActions';
export interface PublishedConnectionTableSpaceHeaderProps extends SiteUrlsProps {
  readonly itemInfo: ISpaceItemDetailInfo<'publishedConnectionTable'>;
  readonly availableActions: IPublishedConnectionTableActions;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}

export function PublishedConnectionTableSpaceHeader(props: PublishedConnectionTableSpaceHeaderProps): JSX.Element {
  const tagUrl = React.useCallback((tag: string) => props.urls.publishedConnectionTablesWithTagUrl(tag), [props.urls]);

  return (
    <ConnectedSpaceHeader
      item={props.itemInfo}
      availableActions={{ ...props.availableActions }}
      nameRowIcons={
        <React.Fragment>
          {FavoriteToggleWithCountsIcon({
            item: props.itemInfo,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          })}
          {ActionsMenuIcon(props.itemInfo)}
        </React.Fragment>
      }
      metadataRow={
        <React.Fragment>
          {OwnerMetadata(props.itemInfo.owner, props.urls)}
          {ModifiedDateMetadata(props.itemInfo.updatedAt)}
          {ExtractStatusMetadata(props.itemInfo.hasExtracts)}
          {isPublishedConnectionTableInfo(props.itemInfo) && PublishedConnectionPolicyMetaData(props.itemInfo)}
        </React.Fragment>
      }
      spotlightActions={[EditPublishedConnectionEntityAction]}
      descriptionElement={ItemDescription(props.itemInfo, props.openDetail, sanitize)}
    />
  );
}
